/**
 * Axios interceptor config to retrieve an access token before making a request.
 */
export default (({
  getToken
}) => ({
  success: async config => {
    const newConfig = config;
    const token = await getToken();
    newConfig.headers.Authorization = token ? `Bearer ${token}` : null;
    return newConfig;
  },
  error: error => Promise.reject(error)
}));